import HundredBricksAPIError from '../../HundredBricksAPIError';
class SetFiscalRegimeError extends HundredBricksAPIError {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(...args) {
        super('SetFiscalRegimeError', ...args);
    }
}
export default SetFiscalRegimeError;
